package io.horion.auth.domain.models

enum class ProfileSection { HOME, PERSONAL_INFO, SECURITY }
